import React from 'react';
import RainFlowAnalytics from './components/RainFlowAnalytics';
import './App.css';

function App() {
  return (
    <div className="App">
      <RainFlowAnalytics />
    </div>
  );
}

export default App;